<template>
    <div class="main-container">
        <router-view></router-view>
		<!-- Navbar section -->
		<HeaderSoftware />

        <!-- breadcrumb strat -->
        <Breadcrumb>
            <template slot="breadcrumb">
                <div class="breadcrumb_box text-center">
                    <h2 class="breadcrumb-title">{{$t('il')}}</h2>
                    <!-- breadcrumb-list start -->
                    <ul class="breadcrumb-list">
                        <li class="breadcrumb-item"><router-link :to="{name:'HomeBranding'}">{{$t('home')}}</router-link></li>
                        <li class="breadcrumb-item active">{{$t('il')}}</li>
                        <li class="breadcrumb-item active">{{sIl}}</li>
                    </ul>
                    <!-- breadcrumb-list end -->
                </div>
            </template>
        </Breadcrumb>
        <!-- breadcrumb end -->
        <div class="container clearfix">
								<div class="slider-caption slider-caption-center">
									<!-- <h2 class="font-primary">İnanılmaz Hedefler</h2> -->
                                    <div class="center col-lg-8 offset-lg-2 bottommargin">
							        <h3 class="text-rotater font-secondary" data-separator="," data-rotate="fadeInRight" data-speed="3500"> <span class="t-rotate color">Adana Barkod, Adıyaman Barkod, Afyon Barkod, Ağrı Barkod, Amasya Barkod, Ankara Barkod, Antalya Barkod, Artvin Barkod, Aydın Barkod, Balıkesir Barkod, Bilecik Barkod, Bingöl Barkod, Bitlis Barkod, Bolu Barkod, Burdur Barkod, Bursa Barkod, Çanakkale Barkod, Çankırı Barkod, Çorum Barkod, Denizli Barkod, Diyarbakır Barkod, Edirne Barkod, Elazığ Barkod, Erzincan Barkod, Erzurum Barkod, Eskişehir Barkod, Gaziantep Barkod, Giresun Barkod, Gümüşhane Barkod, Hakkari Barkod, Hatay Barkod, Isparta Barkod, Mersin Barkod, İstanbul Barkod, İzmir Barkod, Kars Barkod, Kastamonu Barkod, Kayseri Barkod, Kırklareli Barkod, Kırşehir Barkod, Kocaeli Barkod, Konya Barkod, Kütahya Barkod, Malatya Barkod, Manisa Barkod, Kahramanmaraş Barkod, Mardin Barkod, Muğla Barkod, Muş Barkod, Nevşehir Barkod, Niğde Barkod, Ordu Barkod, Rize Barkod, Sakarya Barkod, Samsun Barkod, Siirt Barkod, Sinop Barkod, Sivas Barkod, Tekirdağ Barkod, Tokat Barkod, Trabzon Barkod, Tunceli Barkod, Şanlıurfa Barkod, Uşak Barkod, Van Barkod, Yozgat Barkod, Zonguldak Barkod, Aksaray Barkod, Bayburt Barkod, Karaman Barkod, Kırıkkale Barkod, Batman Barkod, Şırnak Barkod, Bartın Barkod, Ardahan Barkod, Iğdır Barkod, Yalova Barkod, Karabük Barkod, Kilis Barkod, Osmaniye Barkod, Düzce Barkod</span><br> Barkod Yazılımevi ®</h3>
						            </div>
									<p class="t300 font-primary d-none d-sm-block">E-ticaret beklentilerinizi ve hedeflerinizi birlikte geliştirelim.</p>
									<!-- <a title="Shop" href="shop" class="button button-rounded button-large nott ls0 font-primary">Mağaza</a> -->
								</div>
							</div>

         <!-- footer section -->
        <FooterMain />

        <!-- offcanvas search component -->
        <OffcanvasSearchBox />

        <!-- off-canvas mobile menu -->
        <OffCanvasMobileMenu />
    </div>
</template>
<script>
import HeaderSoftware from "../components/HeaderSoftware";
import Breadcrumb from '@/components/Breadcrumb'
import FooterMain from '@/components/FooterMain'
import OffcanvasSearchBox from '@/components/OffcanvasSearchBox'
import OffCanvasMobileMenu from '@/components/OffCanvasMobileMenu'
export default {
     
     components: {
     HeaderSoftware,
     Breadcrumb,
     FooterMain,
     OffcanvasSearchBox,
     OffCanvasMobileMenu
     },
     data(){
         return {
             sPlaka:null,
             sIl:null,
         }
     },
     created(){
         this.sPlaka = this.$route.params.sPlaka;
         this.sIl = this.$route.params.sIl;
         document.title = this.$route.params.sIl.replace('-',' ')
     }
}
</script>
